import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../ricos-context';
import { getIsModalOpen, useModalState } from './../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../ricos-types';
import { EditIcon, ToggleButton } from './../../toolbars-ui';

import { AUDIO_SETTINGS_MODAL_ID } from '../consts';

type Props = {
  toolbarItem: IToolbarItem;
  dataHook?: string;
};

export const AudioEditButton: FC<Props> = ({ toolbarItem, dataHook }) => {
  const { isMobile, t } = useContext(RicosContext) || {};
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const isModalOpen = useModalState(getIsModalOpen(AUDIO_SETTINGS_MODAL_ID));

  const onClick = () => toolbarItem.commands.click({ referenceElement, isMobile });

  return (
    <ToggleButton
      dataHook={dataHook}
      Icon={EditIcon}
      active={isModalOpen}
      label={t('AudioPlugin_Toolbar_Edit_Label')}
      tooltip={t('AudioPlugin_Toolbar_Edit_Label')}
      onClick={onClick}
      setRef={setReferenceElement}
    />
  );
};
